import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import humanTime from 'flarum/common/helpers/humanTime';
import classList from 'flarum/common/utils/classList';
import SubtreeRetainer from 'flarum/common/utils/SubtreeRetainer';
import WarningPost from './WarningPost';
import WarningControls from './WarningControls';
export default class WarningListItem extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "subtree", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.subtree = new SubtreeRetainer(() => this.attrs.warning.freshness, () => this.attrs.warning.isHidden());
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    return this.subtree.needsRebuild();
  }
  view() {
    var _app$session$user;
    const {
      warning
    } = this.attrs;
    const addedByUser = warning.addedByUser();
    const post = warning.post();
    const controls = WarningControls.controls(warning, this).toArray();
    return m("div", this.elementAttrs(), Dropdown.component({
      icon: 'fas fa-ellipsis-v',
      className: classList('WarningListItem-controls', {
        hidden: !controls.length
      }),
      buttonClassName: 'Button Button--icon Button--flat Slidable-underneath Slidable-underneath--right'
    }, controls), m("div", {
      className: "WarningListItem-main"
    }, m("h3", {
      className: "WarningListItem-title"
    }, m(Link, {
      href: addedByUser ? app.route.user(addedByUser) : '#',
      className: "WarningListItem-author"
    }, m(Avatar, {
      user: addedByUser || null
    }), " ", username(addedByUser))), m("span", {
      className: "WarningListItem-strikes"
    }, warning.isHidden() ? app.translator.trans('fof-moderator-warnings.forum.warning_list_item.list_item_heading_hidden', {
      time: humanTime(warning.createdAt()),
      strikes: warning.strikes() || 0
    }) : app.translator.trans('fof-moderator-warnings.forum.warning_list_item.list_item_heading', {
      time: humanTime(warning.createdAt()),
      strikes: warning.strikes() || 0
    })), m("hr", null), m("ul", {
      className: "WarningListItem-info"
    }, post ? m("li", {
      className: "item-excerpt"
    }, m("h3", {
      className: "WarningListItem-subtitle"
    }, app.translator.trans('fof-moderator-warnings.forum.warning_list_item.linked_post')), WarningPost.component({
      post
    })) : '', m("li", {
      className: "item-excerpt"
    }, m("h3", {
      className: "WarningListItem-subtitle"
    }, app.translator.trans('fof-moderator-warnings.forum.warning_list_item.public_comment')), m("p", {
      className: "WarningListItem-comment"
    }, m.trust(warning.publicComment()))), (_app$session$user = app.session.user) != null && _app$session$user.canManageWarnings() && warning.privateComment() ? m("li", {
      className: "item-excerpt"
    }, m("h3", {
      className: "WarningListItem-subtitle"
    }, app.translator.trans('fof-moderator-warnings.forum.warning_list_item.private_comment')), m("p", {
      className: "WarningListItem-comment"
    }, m.trust(warning.privateComment()))) : '')));
  }
  elementAttrs() {
    const {
      warning
    } = this.attrs;
    return {
      className: classList({
        WarningListItem: true,
        'WarningListItem--hidden': warning.isHidden()
      })
    };
  }
}
flarum.reg.add('fof-moderator-warnings', 'forum/components/WarningListItem', WarningListItem);